import { render, staticRenderFns } from "./FundsFilter.vue?vue&type=template&id=5b0eead3&scoped=true"
import script from "./FundsFilter.vue?vue&type=script&lang=js"
export * from "./FundsFilter.vue?vue&type=script&lang=js"
import style0 from "./FundsFilter.vue?vue&type=style&index=0&id=5b0eead3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0eead3",
  null
  
)

export default component.exports